module.exports = __webpack_public_path__ + "img/ICONE-REMPLACER.0d237389.svg";